import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectModalTypes } from '../../../../../core/legacy/reducers/modals';
import editProjectSections from '../../../../../core/project/commands/EditProjectSections';
import { currentProjectIdQuery, selectedProjectSectionsQuery } from '../../../../../core/project/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import { useProjectSnackbar } from '../../ProjectSnackbarContext';

const EMPTY_VALUE = '';

const EditProjectSectionRepairFollowUpModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedProjectSections = useAppSelector(selectedProjectSectionsQuery);
    const checkedProjectSectionsIds = checkedProjectSections.map((s) => s.id);
    const currentProjectId = useAppSelector(currentProjectIdQuery);
    const { setSnackbarMessage } = useProjectSnackbar();

    const [repairFollowUp, setRepairFollowUp] = useState<string>(EMPTY_VALUE);
    const valueOptions = ['budgeté', 'commandé', 'en cours', 'à récéptionner'];

    useEffect(() => {
        const repairFollowUps = checkedProjectSections
            .map((ps) => ps.repairFollowUp)
            .filter((rfu) => rfu !== undefined && rfu !== null)
            .reduce((acc, val) => acc.add(val!), new Set<string>());
        if (repairFollowUps.size === 1) {
            setRepairFollowUp(repairFollowUps.values().next().value as string);
        } else {
            setRepairFollowUp(EMPTY_VALUE);
        }
    }, [checkedProjectSections]);

    const onValidate = async () => {
        if (!currentProjectId) {
            setSnackbarMessage(t('projectList.error.noProjectSelected'));

            return;
        }

        try {
            await dispatch(
                editProjectSections({
                    projectSectionData: {
                        repairFollowUp: repairFollowUp === EMPTY_VALUE ? null : (repairFollowUp as any),
                    },
                    projectSectionIds: checkedProjectSectionsIds,
                }),
            ).unwrap();
            setRepairFollowUp(EMPTY_VALUE);
        } catch (err) {
            console.error('Error editing project sections:', err);
            setSnackbarMessage(t('projectList.error.default'));
        }
    };

    const handleChange = (event: SelectChangeEvent<string>) => {
        setRepairFollowUp(event.target.value);
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ProjectModalTypes.PROJECT_SECTION_EDIT_REPAIR_FOLLOW_UP}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('projectList.modals.editRepairFollowUp')}</ModalTitle>
                <FormControl fullWidth variant="standard">
                    <Select value={repairFollowUp} onChange={handleChange} autoFocus>
                        <MenuItem value={EMPTY_VALUE}>-</MenuItem>
                        {valueOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </ContentContainer>
        </GenericModal>
    );
};

export default EditProjectSectionRepairFollowUpModal;
